import React, { useContext } from 'react'
import { LinearProgress } from '@mui/material'
import PageHeader from '../../components/PageHeader'

import { UserContext } from '../../context'
import {
  isCurrentAnyMemberOfFMAOrOtherOrganization,
  isStudent,
  showStudentMembershipApplication,
  userFoundInAapeli
} from '../../utils/membershipChecks'
import MainInfo from './MainInfo'
import MembershipInfo from './MembershipInfo'
import Merchandice from './Merchandice'
import PersonalInfo from './PersonalInfo'
import WorkInfo from './WorkInfo'
import Qualifications from './Qualifications'
import Applications from './Applications'

const LandingPage = () => {
  const applications = true
  const { user } = useContext(UserContext)
  const userIsCurrentMember = isCurrentAnyMemberOfFMAOrOtherOrganization(user)
  const userIsStudentMember = isStudent(user)
  const aapeliStudentUnderThreshold =
    userFoundInAapeli(user) && !showStudentMembershipApplication(user)
  const studentEligible = showStudentMembershipApplication(user)

  return user ? (
    <>
      <PageHeader />
      <MainInfo />
      {(userIsCurrentMember || userIsStudentMember) && <PersonalInfo />}
      {applications && <Applications />}
      {user?.qualifications?.length > 0 && <Qualifications />}
      {(userIsCurrentMember || userIsStudentMember) && <WorkInfo />}
      {(userIsCurrentMember || studentEligible || aapeliStudentUnderThreshold) && (
        <MembershipInfo />
      )}
      {(userIsCurrentMember || userIsStudentMember) && <Merchandice />}
    </>
  ) : (
    <LinearProgress />
  )
}

export default LandingPage
